<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <!-- style="height: 100%;"> -->
      <!-- <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#" @click.prevent>
            <span>Danh sách nhân viên</span>
          </a>
        </li>
      </ol>-->
      <div id="employee_fulid" class="container-fluid">
        <div class="form-inline">
          <button
            class="btn btn-info mb-2"
            @click.prevent="addItem"
            v-if="hoso_create"
          >
            <i class="fas fa-plus"></i>
            Add
            <!-- Thêm -->
          </button>
          <!-- <div style="flex-grow: 1" /> -->
          <!-- <b-form-input v-model="query"></b-form-input>
          <button class="btn btn-info" @click.prevent="queryItem">
            <i class="fas fa-search"></i>
          </button>-->
        </div>
        <!-- <div> -->
        <!-- <b-row style="width: 100%;"> -->
        <b-row>
          <b-col cols="12">
            <div class="form-inline" style="width: 100%">
              <b-form-input
                style="flex-grow: 1"
                v-model="query"
                placeholder="Search by Employee ID, Name, Email"
                @keydown.enter.prevent="queryItem"
              ></b-form-input>
              <button class="btn" @click.prevent="queryItem">
                <i class="fas fa-search"></i>
              </button>
              <button class="btn" id="popover-target-1">
                <i class="fas fa-filter"></i>
              </button>
            </div>
            <b-popover target="popover-target-1" triggers="click blur">
              <template v-slot:title>
                Filter by Working Status
                <!-- Lọc nhân viên -->
              </template>
              <!-- <b-form-select
                  v-model="employeeStatus"
                  :options="optionStatus"
                  value-field="id"
                  text-field="pickListValue"
                  @change="filterEmployee"
                > -->
              <!-- <template v-slot:first>
                    <b-form-select-option value="-1"
                      >Tất cả</b-form-select-option
                    >
                  </template> -->
              <b-form-select
                v-model="employeeStatus"
                :options="optionStatus"
                @change="filterEmployee"
              >
              </b-form-select>
            </b-popover>
            <!-- @scroll.native="tableScroll" -->
            <b-table
              id="my-table"
              head-variant="dark"
              hover
              responsive
              striped
              small
              bordered
              sticky-header="true"
              :no-border-collapse="true"
              :fields="fields"
              :items="items"
              table-variant="light"
              no-local-sorting
              @sort-changed="sortChanged"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              selectable
              select-mode="single"
              @row-clicked="onRowClicked"
            >
              <!-- <template v-slot:cell(manhanvien)="data">
                  <b-link v-if="hoso_read" href="#" @click="updateItem(data.item)">{{data.value}}</b-link>
                </template> -->
              <template slot="row-details">
                <b-card>
                  <div>
                    <thong-tin-chung-view
                      :item="item"
                      :linemanager="linemanager"
                      :departments="departments"
                      :vitricongviecs="vitricongviecs"
                    ></thong-tin-chung-view>
                  </div>
                </b-card>
              </template>
              <template v-slot:cell(ngaysinh)="data">{{
                formatDate(data.value)
              }}</template>
              <template v-slot:cell(cmndngaycap)="data">{{
                formatDate(data.value)
              }}</template>
              <template v-slot:cell(ngaythuviec)="data">{{
                formatDate(data.value)
              }}</template>
              <template v-slot:cell(ngaychinhthuc)="data">{{
                formatDate(data.value)
              }}</template>
              <template v-slot:cell(vitricongviec)="data">{{
                data.item.employeeContract == null
                  ? ""
                  : findFirst(
                      vitricongviecs,
                      data.item.employeeContract.vitricongviec
                    )
              }}</template>
              <template v-slot:cell(loaihopdong)="data">{{
                data.item.employeeContract == null
                  ? ""
                  : findFirst(
                      loaihopdongs,
                      data.item.employeeContract.loaihopdong
                    )
              }}</template>
              <template v-slot:cell(donvicongtac)="data">{{
                data.item.employeeContract == null
                  ? ""
                  : findFirstDepartment(
                      departments,
                      data.item.employeeContract.donvicongtac
                    )
              }}</template>
              <template v-slot:cell(trangthai)="data">
                <div v-if="data.item.employeeContract != null">
                  <!-- {{
                    data.item.employeeContract.status == 0
                      ? "Đã nghỉ việc"
                      : "Đang làm việc"
                  }} -->
                  {{
                    data.item.employeeContract.status == 0
                      ? "Quit Job"
                      : "Working"
                  }}
                </div>
              </template>
              <template v-slot:cell(tinhtranghoso)="data">
                <b-badge variant="success" v-if="data.value == 66">{{
                  findEStatus(
                    findFirst(tinhtranghosos, data.item.tinhtranghoso)
                  )
                }}</b-badge>
                <b-badge
                  variant="danger"
                  v-if="data.value == 67 || data.value == 69"
                  >{{
                    findEStatus(
                      findFirst(tinhtranghosos, data.item.tinhtranghoso)
                    )
                  }}</b-badge
                >
                <b-badge variant="primary" v-if="data.value == 68">{{
                  findEStatus(
                    findFirst(tinhtranghosos, data.item.tinhtranghoso)
                  )
                }}</b-badge>
                <b-badge variant="warning" v-if="data.value == 2233">{{
                  findEStatus(
                    findFirst(tinhtranghosos, data.item.tinhtranghoso)
                  )
                }}</b-badge>
                <b-badge variant="secondary" v-if="data.value > 2233">{{
                  findEStatus(
                    findFirst(tinhtranghosos, data.item.tinhtranghoso)
                  )
                }}</b-badge>
              </template>
              <template v-slot:cell(action)="data">
                <b-link
                  v-if="hoso_update || hoso_read"
                  class="text-primary mr-2"
                  href="#"
                  @click="updateItem(data.item)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </b-link>
                <b-link
                  v-if="hoso_delete"
                  class="text-danger mr-2"
                  href="#"
                  @click.prevent="deleteItem(data)"
                >
                  <i class="fas fa-trash"></i>
                </b-link>
                <b-link v-if="hoso_print" class="text-success" href="#">
                  <i class="fas fa-print"></i>
                </b-link>
              </template>
            </b-table>
            <b-badge variant="light">
              Total: {{ totalRow }} employees
              <!-- Tổng số: {{ totalRow }} nhân viên -->
            </b-badge>
            <b-badge
              variant="light"
              v-if="item != null"
              style="float: right; width: 3%"
              @click.prevent="closePopUp"
              ><i class="fas fa-angle-double-down"></i
            ></b-badge>
            <!-- {{scrollTop}}
              {{scrollHeight}}
              {{offsetTop}}
              {{offsetHeight}}-->
            <!-- <b-pagination
                v-if="currentPage != null"
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                @change="paginationChanged"
                first-number
                last-number
              ></b-pagination>-->
          </b-col>
          <!-- <b-col cols="12">
              <b-card no-body v-if="item != null" style="width: 100%">
                <div>
                  <thong-tin-chung-view
                    :item="item"
                    :departments="departments"
                    :vitricongviecs="vitricongviecs"
                  ></thong-tin-chung-view>
                </div>
              </b-card>
            </b-col> -->
        </b-row>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ThongTinChungView from "../components/Employee/ThongTinChungView";
export default {
  name: "Employees",
  components: {
    ThongTinChungView,
  },
  data() {
    return {
      fields: [
        {
          key: "manhanvien",
          // label: "Mã NV",
          label: "Code",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "hovaten",
          // label: "Họ và tên",
          label: "Name",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "430px !important", textAlign: "center" },
        },
        {
          key: "vitricongviec",
          label: "Position",
          // label: "Chức danh",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "240px", textAlign: "center" },
        },
        {
          key: "ngaysinh",
          label: "Date of Birth",
          // label: "Ngày sinh",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        {
          key: "cmndso",
          label: "ID",
          // label: "CMND",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        // @Edit Thanh
        // {
        //   key: "cmndngaycap",
        //   label: "Ngày cấp",
        //   sortable: true,
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: {width: "120px", textAlign : "center"},
        // },
        // {
        //   key: "cmndnoicap",
        //   label: "Nơi cấp",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {width: "160px", textAlign : "center"},
        // },
        {
          key: "dtdidong",
          label: "Phone No.",
          // label: "Điện thoại",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "130px", textAlign: "center" },
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "tinhtranghoso",
          label: "Status",
          // label: "Tình trạng",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          // thStyle: {width: "80px !important" , textAlign : "center"},
          thStyle: { width: "100px", textAlign: "center" },
        },
      ],
      items: [],
      linemanagers: [],
      currentPage: null,
      totalRow: null,
      // perPage: null,
      sortBy: null,
      sortDesc: null,
      query: null,
      tabIndex: 0,
      item: null,
      linemanager: null,
      vitricongviecs: [],
      loaihopdongs: [],
      departments: [],
      tinhtranghosos: [],
      employeeStatus: 0, //default is Dang lam viec
      optionStatus: [
        { value: -1, text: "All" },
        { value: 0, text: "Working" },
        { value: 67, text: "Quit job" },
        { value: 66, text: "Official staff" },
        { value: 68, text: "Probation" },
        { value: 2233, text: "Intern" },
        { value: 20303, text: "Collaborator" },

        // { value: -1, text: "Tất cả" },
        // { value: 0, text: "Đang làm việc" },
        // { value: 67, text: "Nghỉ việc" },
        // { value: 66, text: "Chính thức" },
        // { value: 68, text: "Thử việc" },
        // { value: 2233, text: "Thực tập" },
        // { value: 20303, text: "Cộng tác viên" },
      ],
      scrollTop: 0,
      scrollHeight: 0,
      offsetTop: 0,
      offsetHeight: 0,
      headerSize: "1000000000000000px",

      old_row: null,
      openDetail: true,
    };
  },
  computed: {
    //Permission create (button Them), edit/delete/print (action)
    hoso_read() {
      return this.$store.getters.hasPermission("hoso_read");
    },
    hoso_create() {
      return this.$store.getters.hasPermission("hoso_create");
    },
    hoso_update() {
      return this.$store.getters.hasPermission("hoso_update");
    },
    hoso_delete() {
      return this.$store.getters.hasPermission("hoso_delete");
    },
    hoso_print() {
      return this.$store.getters.hasPermission("hoso_print");
    },
  },
  beforeRouteEnter(to, from, next) {
    //let query = Object.assign({}, this.$route.query);
    //query.status = 0;
    //query.page = this.currentPage;
    // eslint-disable-next-line no-console
    to.query.status = 0; //console.log(query);
    axios
      .all([
        axios.get("/api/picklist?q=vitricongviec|loaihopdong|tinhtranghoso"),
        axios.get("/api/department"),
        axios.get(`/api/employee`, { params: to.query }),
        axios.get("/api/employee/getlinemanager"),
      ])
      .then(
        axios.spread((picklist, department, item, linemanager) => {
          next((vm) =>
            vm.initData(
              picklist.data,
              department.data,
              item.data,
              linemanager.data
            )
          );
        })
      );
    // axios.get(`/api/employee`, { params: to.query }).then((response) => {
    //   next((vm) => vm.initData(response.data));
    // });
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/employee", { params: to.query })
      .then((response) => {
        this.items = response.data.items;
        // this.perPage = response.data.perPage;
        this.currentPage = response.data.currentPage;
        this.totalRow = response.data.totalRow;
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    initData(picklists, departments, data, linemanagers) {
      //this.vitricongviecs = vitricongviecs;
      this.vitricongviecs = picklists.filter(
        (x) => x.pickListType == "vitricongviec"
      );
      this.loaihopdongs = picklists.filter(
        (x) => x.pickListType == "loaihopdong"
      );
      this.tinhtranghosos = picklists.filter(
        (x) => x.pickListType == "tinhtranghoso"
      );
      this.departments = departments;
      this.items = data.items;
      this.linemanagers = linemanagers;
      // this.perPage = data.perPage;
      this.currentPage = data.currentPage;
      this.sortBy = data.sortBy;
      this.sortDesc = data.sortDesc;
      this.totalRow = data.totalRow;
    },
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    findEStatus(status) {
      switch (status) {
        case "On working":
          status = "Working";
          break;
        case "Leave":
          status = "Quit job";
          break;
        case "Probation":
          status = "Probation";
          break;
        case "Intern":
          status = "Intern";
          break;
        case "Collaborator":
          status = "Collaborator";
          break;
      }
      return status;
    },
    findLineManager(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? null : temp;
    },
    formatDate(value) {
      if (!value) return "";
      //this.$log(this.$moment(value).format("DD/MM/YYYY"));
      return this.$moment(value).format("DD/MM/YYYY");
    },
    sortChanged(ctx) {
      this.item = null;
      let query = Object.assign({}, this.$route.query);
      query.sortBy = ctx.sortBy;
      query.sortDesc = ctx.sortDesc;
      this.$router.push({ query: query });
    },
    paginationChanged(ctx) {
      this.item = null;
      let query = Object.assign({}, this.$route.query);
      query.page = ctx;
      this.$router.push({ query: query });
    },
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.status = this.employeeStatus;
      this.currentPage = 1;
      query.page = 1;
      this.item = null;
      this.$router.push({ query: query });
    },
    onRowSelected(item) {
      this.headerSize = "580px";
      if (item.length > 0) {
        axios
          .get(`/api/employee/${item[0].manhanvien}`)
          .then((response) => {
            this.item = response.data.employee;
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          });
      }
    },
    onRowClicked(row) {
      row._showDetails = !row._showDetails;

      if (this.old_row != null && this.old_row != row)
        this.old_row._showDetails = false;
      this.old_row = row;
      if (!row._showDetails) return;

      axios
        .get(`/api/employee/${row.manhanvien}`)
        .then((response) => {
          this.item = response.data.employee;
          if (this.item.employeeGroup != null) {
            if (this.item.employeeGroup.employeeid2)
              this.linemanager = this.findLineManager(
                this.linemanagers,
                this.item.employeeGroup.employeeid2
              );
          } else this.linemanager = null;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    addItem() {
      this.$router.push(`/add_hr_record`);
    },
    updateItem(item) {
      this.$router.push(`/hr_record/${item.manhanvien}`);
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`api/employee/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    filterEmployee() {
      let query = Object.assign({}, this.$route.query);
      query.status = this.employeeStatus;
      query.page = 1;
      this.currentPage = 1;
      this.$router.push({ query: query });
    },
    tableScroll(evt) {
      if (
        evt.target.scrollHeight > 0 &&
        evt.target.scrollTop + evt.target.offsetHeight ==
          evt.target.scrollHeight
      ) {
        //this.item = null;
        let query = Object.assign({}, this.$route.query);
        this.currentPage = this.currentPage + 1;
        query.page = this.currentPage;
        // eslint-disable-next-line no-console
        //console.log(query);
        axios
          .get("/api/employee", { params: query })
          .then((response) => {
            let i = 0;
            for (i = 0; i < response.data.items.length; i++) {
              this.items.push(response.data.items[i]);
            }
          })
          .catch((err) => {});
      }
      // this.scrollTop = evt.target.scrollTop;
      // this.scrollHeight = evt.target.scrollHeight;
      // this.offsetTop = evt.target.offsetTop;
      // this.offsetHeight = evt.target.offsetHeight;
    },
    closePopUp() {
      this.item = null;
      this.headerSize = "1000000000000000px";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* #employee_fulid .table-responsive {
  height: calc(100vh - 242px);
} */
#employee_fulid .b-table-sticky-header {
  height: calc(100vh - 204px);
  max-height: unset;
}
</style>
